module.exports = __webpack_public_path__ + "loader.34e2db6e3254ab0759f1.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loader.gif
// module id = 1507
// module chunks = 2